import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import { I18nProvider } from "@/lib/i18n";
import AppShell from "@/components/layout/AppShell";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import LiveMap from "@/pages/LiveMap";
import Vehicles from "@/pages/Vehicles";
import Drivers from "@/pages/Drivers";
import Journeys from "@/pages/Journeys";
import UberImport from "@/pages/UberImport";
import Reconciliation from "@/pages/Reconciliation";
import TripDetail from "@/pages/TripDetail";
import DeviceHealth from "@/pages/DeviceHealth";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";
import Passengers from "@/pages/Passengers";
import CCTV from "@/pages/CCTV";
import Assistant from "@/pages/Assistant";
import Scorecard from "@/pages/Scorecard";
import Tenants from "@/pages/Tenants";
import { Spinner } from "@/components/shared";

function Protected({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  if (user === null) return <div className="h-screen flex items-center justify-center"><Spinner /></div>;
  if (user === false) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

export default function App() {
  return (
    <I18nProvider>
      <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<Protected><AppShell /></Protected>}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/map" element={<LiveMap />} />
            <Route path="/vehicles" element={<Vehicles />} />
            <Route path="/drivers" element={<Drivers />} />
            <Route path="/journeys" element={<Journeys />} />
            <Route path="/uber" element={<UberImport />} />
            <Route path="/reconciliation" element={<Reconciliation />} />
            <Route path="/reconciliation/:id" element={<TripDetail />} />
            <Route path="/health" element={<DeviceHealth />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/tenants" element={<Tenants />} />
            <Route path="/passengers" element={<Passengers />} />
            <Route path="/cctv" element={<CCTV />} />
            <Route path="/assistant" element={<Assistant />} />
            <Route path="/scorecard" element={<Scorecard />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" richColors />
      </AuthProvider>
    </I18nProvider>
  );
}
